export const PRICING_REQUEST = 'PRICING_REQUEST';
export const PRICING_SUCCESS = 'PRICING_SUCCESS';
export const PRICING_FAIL = 'PRICING_FAIL';
